import React from "react";
import {
	SectionDivider,
	SectionHeading,
	SettingsFormContainer,
	SaveSettingButton,
	FieldsContainer,
} from "../../styles/common.styles";
import SettingsTextField from "../../components/SettingsTextField";
import SettingsSwitchField from "../../components/SettingsSwitchField";
import SettingsSnackbar from "../../components/SettingsSnackbar";

import { AlertColor } from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

interface Props {
	handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
	settings: Record<string, string | boolean | string[]>;
	setSettings: React.Dispatch<
		React.SetStateAction<Record<string, string | boolean | string[]>>
	>;
	setSettingsPromise: (
		value: React.SetStateAction<Record<string, string | boolean | string[]>>,
	) => Promise<Record<string, string | boolean | string[]>>;
	notice: { type: AlertColor; message: string };
	showNotice: boolean;
	setShowNotice: React.Dispatch<React.SetStateAction<boolean>>;
	loading: boolean;
	handleUpdateSettings: (
		settings: Record<string, string | boolean | string[]>,
	) => void;
}

const GeneralSettings = ({
	handleSubmit,
	settings,
	notice,
	showNotice,
	setSettings,
	setSettingsPromise,
	setShowNotice,
	loading,
	handleUpdateSettings,
}: Props) => {
	return (
		<SettingsFormContainer>
			<form onSubmit={(e) => handleSubmit(e)}>
				<SettingsSnackbar
					notice={notice}
					showNotice={showNotice}
					setShowNotice={setShowNotice}
				/>
				<FieldsContainer>
					<SectionHeading variant='h6'>Twilio settings</SectionHeading>
					<SettingsTextField
						settings={settings}
						setSettings={setSettings}
						label='Account SID'
						slug='account-sid'
						helper='Twilio SID. You get this when create a twilio account.'
					/>
					<SettingsTextField
						settings={settings}
						setSettings={setSettings}
						label='Auth Token'
						slug='auth-token'
						helper='Twilio Auth token secret. You get this when create a twilio account.'
					/>
					<SettingsTextField
						settings={settings}
						setSettings={setSettings}
						label='From Phone'
						slug='from-phone'
						helper='The registered phone number on Twilio. You will use this number to send SMS for your store.'
					/>

					<SectionDivider />

					<SectionHeading variant='h6'>Twilio test settings</SectionHeading>
					<SettingsSwitchField
						settings={settings}
						setSettingsPromise={setSettingsPromise}
						label='Enable Test Mode'
						slug='enable-test-mode'
						helper={
							<Typography variant='subtitle2' sx={{ p: 2 }}>
								Test mode is to test messages that will be sent for order
								notification. A real SMS message will not be sent when test mode
								is on.{" "}
								<a
									href='https://www.messageflow.co/'
									target='_blank'
									rel='noreferrer'>
									Read More
								</a>
							</Typography>
						}
						handleUpdateSettings={handleUpdateSettings}
					/>

					<SettingsTextField
						settings={settings}
						setSettings={setSettings}
						label='Test Account SID'
						slug='test-account-sid'
					/>
					<SettingsTextField
						settings={settings}
						setSettings={setSettings}
						label='Test Auth Token'
						slug='test-auth-token'
					/>
					<SettingsTextField
						settings={settings}
						setSettings={setSettings}
						label='Test From Phone'
						slug='test-from-phone'
					/>
				</FieldsContainer>

				<SaveSettingButton
					loading={loading}
					size='large'
					variant='contained'
					type='submit'>
					Save settings
				</SaveSettingButton>
			</form>
		</SettingsFormContainer>
	);
};

export default GeneralSettings;
